// Pure game rules: no rendering, no platform code, so they run in plain unit tests.

export interface TapRules {
  coinsPerTap: number;
  comboWindowMs: number;
  comboMultiplierMax: number;
}

export interface TapState {
  coins: number;
  combo: number;
  lastTapAt: number;
}

export const defaultRules: TapRules = {
  coinsPerTap: 1,
  comboWindowMs: 600,
  comboMultiplierMax: 5,
};

export function initialState(coins = 0): TapState {
  return { coins, combo: 0, lastTapAt: Number.NEGATIVE_INFINITY };
}

/** Applies one tap at time `now` (ms) and returns the new state and the coins earned. */
export function tap(state: TapState, now: number, rules: TapRules = defaultRules): { state: TapState; earned: number } {
  const inCombo = now - state.lastTapAt <= rules.comboWindowMs;
  const combo = inCombo ? Math.min(state.combo + 1, rules.comboMultiplierMax) : 1;
  const earned = rules.coinsPerTap * combo;
  return { state: { coins: state.coins + earned, combo, lastTapAt: now }, earned };
}
